import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaArrowRight, FaCheck, FaEnvelope, FaUserGraduate, FaBriefcase, FaGraduationCap, FaArrowLeft, FaInfoCircle } from 'react-icons/fa';
import { Alert } from 'react-bootstrap';
import Layout from '../components/layout/Layout';
import logo from '../assets/logo.png';
import './RegisterStep1.css';



const RegisterStep1 = () => {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('buyer');
  const [sellerType, setSellerType] = useState('student'); // 'student' or 'professional'
  const [error, setError] = useState('');
  const [emailVerified, setEmailVerified] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if email is verified from location state
  useEffect(() => {
    if (location.state?.email && location.state?.verified) {
      setEmail(location.state.email);
      setEmailVerified(true);
    } else {
      // Redirect to email verification if not verified
      navigate('/verify-email');
    }
    
    // If returning from step 2 with location data, display it
    if (location.state?.location) {
      // We'll use this data when navigating forward
    }
  }, [location.state, navigate]);
  
  const handleRoleChange = (val) => {
    setRole(val);
    setError('');
  };

  const handleSellerTypeSelect = (type) => {
    setSellerType(type);
    setError('');
    // Close dropdown if it's open
    const dropdown = document.getElementById('sellerTypeDropdown');
    if (dropdown && dropdown.classList.contains('show')) {
      dropdown.classList.remove('show');
    }
  };
  
  const validateStep = () => {
    if (!email) {
      setError('Please enter your email address');
      return false;
    }
    
    if (!emailVerified) {
      setError('Your email is not verified. Please verify your email first.');
      return false;
    }
    
    if (role === 'seller' && !sellerType) {
      setError('Please select seller type');
      return false;
    }

    // if (role === 'seller' && sellerType === 'student' && !email.endsWith('.edu')) {
    //  setError('Student sellers must register with a valid .edu email address.');
    //  return false;
    //}
    
    return true;
  };
  
  const handleContinue = (e) => {
    e.preventDefault();
    
    if (validateStep()) {
      // Navigate to step 2 with the form data
      navigate('/register-step-2', { 
        state: { 
          email, 
          role,
          sellerType: role === 'seller' ? sellerType : null,
          verified: emailVerified
        } 
      });
    }
  };
  
  const handleBack = () => {
    // Add a small animation effect before navigation
    const backBtn = document.querySelector('.back-btn');
    if (backBtn) {
      backBtn.classList.add('clicked');
      setTimeout(() => {
        navigate('/register');
      }, 200);
    } else {
      navigate('/register');
    }
  };
  
  return (
    <Layout>
      <div className="register-step1-page-container">
        <div className="register-step1-split-screen">
          <div className="register-step1-left-panel">
            <div className="register-form-container">
              <img src={logo} alt="UniTrade Logo" className="register-logo" />
              <h2>Create Account</h2>
              <p className="step-indicator">Step 1: Account Type</p>
              <div className="progress-bar-step1">
                <div className="progress-step1" style={{ width: '33%' }}></div>
              </div>

              {error && <div className="alert-danger">{error}</div>}

              <form onSubmit={handleContinue} className="register-step1-form">
                <div className="input-group-register">
                  <div className="input-with-icon verified">
                     <FaEnvelope className="input-icon" />
                    <input
                      type="email"
                      value={email}
                      placeholder="nexuscoderdee@gmail.com"
                      readOnly
                      disabled
                    />
                  </div>
                  {emailVerified && <div className="email-verified-text"><FaCheck /> Verified</div>}
                </div>

                <div className="input-group-register">
                  <label>Register as:</label>
                  <div className="role-selector">
                    <button type="button" className={`role-btn ${role === 'buyer' ? 'active' : ''}`} onClick={() => handleRoleChange('buyer')}>BUYER</button>
                    <button type="button" className={`role-btn ${role === 'seller' ? 'active' : ''}`} onClick={() => handleRoleChange('seller')}>SELLER</button>
                  </div>

                  {role === 'seller' && (
                    <div className="input-group-register seller-type-group">
                      <label>Select seller type:</label>
                      <div className="role-selector">
                        <button type="button" className={`role-btn ${sellerType === 'student' ? 'active' : ''}`} onClick={() => handleSellerTypeSelect('student')}>
                          <FaUserGraduate /> Student
                        </button>
                        <button type="button" className={`role-btn ${sellerType === 'professional' ? 'active' : ''}`} onClick={() => handleSellerTypeSelect('professional')}>
                          <FaBriefcase /> Professional
                        </button>
                      </div>
                    </div>
                  )}

                  {role === 'seller' && sellerType === 'student' && (
                    <Alert variant="info" className="mt-3 student-email-alert">
                      <FaInfoCircle className="me-2" />
                      A verification link will be sent to your <strong>.edu</strong> email to activate your seller account.
                    </Alert>
                  )}
                </div>



                <div className="form-navigation">
                  <button type="button" className="back-btn" onClick={handleBack}>
                    <FaArrowLeft /> Back
                  </button>
                  <button type="submit" className="continue-btn">
                    Continue <FaArrowRight />
                  </button>
                </div>
              </form>
              <p className="login-link-p">Have an account? <Link to="/login">Login</Link></p>
            </div>
          </div>
          <div className="register-step1-right-panel">
            <div className="cta-content">
              <FaGraduationCap className="cta-icon" />
              <h2>UniTrade</h2>
              <p>Join our trusted academic marketplace to buy and sell products from students and professionals.</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RegisterStep1;
